module.exports = __webpack_public_path__ + "static/media/landingbottom.21ff79e0.png";